import { Controller } from "stimulus"
import { toDate, toTime } from "../utils/formatters"

export default class extends Controller {
  static targets = ["output", "toggle"]

  toggle(event) {
    const { ioToggleId } = event.currentTarget.dataset
    this.toggleTargets.forEach(target =>
      target.hidden = target.dataset.ioToggleId !== ioToggleId
    )
  }

  update(event) {
    const inputValue = event.currentTarget.dataset.ioOutputValue || event.currentTarget.value

    this.outputTargets.forEach(target => {
      let outputValue
      const { ioOutputFormat, ioOutputId } = target.dataset

      if (ioOutputId === event.currentTarget.dataset.ioOutputId) {
        switch (ioOutputFormat) {
          case "date":
            outputValue = toDate(inputValue)
            break
          case "time":
            outputValue = toTime(inputValue)
            break
          default:
            outputValue = inputValue
        }

        if (target.nodeName === 'INPUT') {
          target.value = outputValue
        } else {
          target.innerText = outputValue
        }
      }
    })
  }
}
